import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const PrivacyPolicy = () => (
  <>
    <Navbar />
    <main className="min-h-screen pt-24 pb-16">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="font-display text-4xl md:text-5xl text-foreground mb-6">Privacy Policy</h1>
        <div className="prose prose-lg text-muted-foreground space-y-4">
          <p><em>Last updated: {new Date().toLocaleDateString("en-US", { month: "long", year: "numeric" })}</em></p>
          <p>
            Elara Health ("we", "our", or "us") is committed to protecting the privacy of our patients
            and website visitors. This policy describes how we collect, use, and safeguard your personal
            and health information.
          </p>
          <h2 className="font-display text-2xl text-foreground">Information We Collect</h2>
          <p>We may collect personal information including your name, email, date of birth, health history, and payment details when you use our platform.</p>
          <h2 className="font-display text-2xl text-foreground">How We Use Your Information</h2>
          <p>Your information is used to provide clinical services, process payments, communicate with you about your care, and improve our platform.</p>
          <h2 className="font-display text-2xl text-foreground">Data Protection</h2>
          <p>We implement industry-standard security measures and comply with applicable healthcare privacy regulations to protect your data.</p>
          <p>For questions about our privacy practices, contact us at <a href="mailto:privacy@elarahealth.life" className="text-champagne hover:underline">privacy@elarahealth.life</a>.</p>
        </div>
      </div>
    </main>
    <Footer />
  </>
);

export default PrivacyPolicy;
